import React from 'react'
import _ from 'lodash'
import { Divider } from '@mui/material'
import FormattedPrice from '@components/FormattedPrice'
import { useTranslation } from 'react-i18next'
import FormattedWeight, { WeightUnitsEnum } from '@components/FormattedWeight'

interface CategoryCartLine {
  pk: number
  pcs: number
  qty: number
  price: number
  weight: number
  category: string
  sortOrder: number
  currency: string
}

interface Props {
  categoriesWithLines: {
    [key: number]: CategoryCartLine[]
  }
}

const CartSummary: React.FC<Props> = ({ categoriesWithLines }) => {
  const { t } = useTranslation()
  const categoryLines = Object.values(categoriesWithLines).flat()
  const totalPrice = _.sumBy(categoryLines, categoryLine => categoryLine.price * categoryLine.qty)
  const totalQty = _.sumBy(categoryLines, categoryLine => categoryLine.qty)
  const totalWeight = _.sumBy(categoryLines, categoryLine => categoryLine.weight * categoryLine.qty)
  const totalItemsCount = categoryLines.length
  const currency = categoryLines[0]?.currency || 'USD'

  return (
    <div className='text-13'>
      {_.orderBy(Object.keys(categoriesWithLines), categoryPk => categoriesWithLines[categoryPk][0]?.sortOrder).map(
        categoryPk => {
          const categoryLines: CategoryCartLine[] = categoriesWithLines[categoryPk]
          const categoryName = categoryLines[0]?.category
          const price = _.sumBy(categoryLines, categoryLine => categoryLine.price * categoryLine.qty)
          const itemsCount = categoryLines.length
          const qty = _.sumBy(categoryLines, categoryLine => categoryLine.qty)
          const weight = _.sumBy(categoryLines, categoryLine => categoryLine.weight * categoryLine.qty)
          return (
            <p key={categoryPk} className='mb-16 mt-0'>
              <span className='uppercase'>{categoryName}: </span>
              <span>
                {t('designsWithCount', { defaultValue: '{{count}} Design', count: itemsCount })}
                &nbsp;-&nbsp;
                {t('pcsWithCount', { defaultValue: '{{count}} pcs', count: qty })}
                &nbsp;-&nbsp;
                <FormattedPrice currency={currency} amount={price} />
                &nbsp;-&nbsp;
                <FormattedWeight value={weight} units={WeightUnitsEnum.KG} sourceUnits={WeightUnitsEnum.G} />
                &nbsp;{t('kg', 'kg')}
              </span>
            </p>
          )
        }
      )}
      <p className='text-bold mb-0'>
        <span className='uppercase'>{t('total', 'Total')}: </span>
        <span>
          {t('designsWithCount', { defaultValue: '{{count}} Design', count: totalItemsCount })}
          &nbsp;-&nbsp;
          {t('pcsWithCount', { defaultValue: '{{count}} pcs', count: totalQty })}
          &nbsp;-&nbsp;
          <FormattedPrice currency={currency} amount={totalPrice} />
          &nbsp;-&nbsp;
          <FormattedWeight value={totalWeight} units={WeightUnitsEnum.KG} sourceUnits={WeightUnitsEnum.G} />
          &nbsp;{t('kg', 'kg')}
        </span>
      </p>
    </div>
  )
}

export default CartSummary
